import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, renderSlot as _renderSlot, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5dea8926"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "menu" }
const _hoisted_2 = { class: "header-container" }
const _hoisted_3 = { class: "footer-container" }

import MenuHeader from "@/lib/components/layout/menu/MenuHeader.vue";
import ScrollableElement from "@/lib/components/flexible/ScrollableElement.vue";
import MenuFooter from "@/lib/components/layout/menu/MenuFooter.vue";


export default /*#__PURE__*/_defineComponent({
  name: 'MenuLayout',
  props: {
  headerText: {
    type: String,
    required: true
  },
  footerText: {
    type: String,
    required: true
  },
},
  setup(__props) {





return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("nav", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(MenuHeader, {
        "header-text": __props.headerText,
        "main-icon": require(`@/assets/logo.png`)
      }, null, 8, ["header-text", "main-icon"])
    ]),
    _createVNode(ScrollableElement, { class: "submenus-container" }, {
      default: _withCtx(() => [
        _renderSlot(_ctx.$slots, "default")
      ]),
      _: 3
    }),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(MenuFooter, { "footer-text": __props.footerText }, null, 8, ["footer-text"])
    ])
  ]))
}
}

})